import type { ChatViewerPresence } from '../../../../types/chat'
import type { ChatMember } from '../../../../context/chatContextCore'
import { useNls } from '../../../../nls/nlsProvider'
import { getChatRoleLabel } from '../../chatShellChrome'
import { MobileSheet } from '../MobileSheet'
import { Avatar } from '../../../Common/Avatar'

type Props = {
  open: boolean
  onClose: () => void
  members: ChatMember[]
  viewerPresence: ChatViewerPresence[]
  channelName: string
}

export const MembersSheet = ({ open, onClose, members, viewerPresence, channelName }: Props) => {
  const { t } = useNls()
  const onlineIds = new Set(viewerPresence.filter((entry) => !!entry.uid).map((entry) => entry.uid))
  const sorted = [...members].sort((a, b) => Number(onlineIds.has(b.uid)) - Number(onlineIds.has(a.uid)) || a.name.localeCompare(b.name))

  return (
    <MobileSheet
      open={open}
      onClose={onClose}
      title={t('NLSChatSheetMembersTitle')}
      hint={channelName}
      ariaLabel={t('NLSChatSheetMembersTitle')}
      testId="member-chat-members-sheet"
    >
      {sorted.length === 0 ? (
        <p style={{ padding: '20px 8px', color: 'var(--muted)', fontSize: 12, fontStyle: 'italic', margin: 0 }}>
          {t('NLSChatMembersEmpty')}
        </p>
      ) : (
        <div>
          {sorted.map((member) => {
            const isOnline = onlineIds.has(member.uid)
            return (
              <div key={member.id || member.uid} className="memberChatRow" role="listitem">
                <Avatar
                  photoURL={member.avatarUrl}
                  name={member.name}
                  size="sm"
                  className="memberChatRow__ic"
                />
                <span className="memberChatRow__body">
                  <span className="memberChatRow__name">
                    {member.name}
                    {isOnline ? <span className="memberChatHeader__dot" aria-hidden="true" /> : null}
                  </span>
                  <span className="memberChatRow__preview">{member.email || (member.role ? getChatRoleLabel(t, member.role) : '')}</span>
                </span>
              </div>
            )
          })}
        </div>
      )}
    </MobileSheet>
  )
}
